import React from "react";
import ReactSlider from "react-slider";
import { RillContext } from "../../rill/RillReact/share/base";

class RangeInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.handleChange = this.handleChange.bind(this);
    this.state = { value: props.defaultValue || [] };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Force the range to go back to default if there is a reset
    if (nextProps.defaultValue !== this.state.value) {
      this.handleChange([nextProps.defaultValue[0], nextProps.defaultValue[1]]);
    }
  }

  handleChange([low, high]) {
    // Snap low and high to step.
    const step = this.props.step;
    low = Math.round(low / step) * step;
    high = Math.round(high / step) * step;
    const value = { value: [low, high] };
    this.setState(value);
    this.refs.range.setState(value);
  }

  render() {
    const { props, state } = this;
    const min = Number(props.min);
    const max = Number(props.max);
    const step = props.step;
    const [low = min, high = max] = state.value;
    return (
      <div className="range-input">
        {props.nameRangeInput && (
          <div className="name-range-input">{props.nameRangeInput}</div>
        )}
        <p className="p1">
          {low === high
            ? Math.max(low, min)
            : `${Math.max(low, min)}-${Math.min(high, max)}`}
        </p>
        <ReactSlider
          ref="range"
          min={min}
          max={max}
          step={1}
          defaultValue={[low, high]}
          onChange={props.onChange}
          onAfterChange={this.handleChange}
          renderTrack={(props, state) => {
            const rangeStart = ((state.value[0] - min) * 100) / (max - min);
            const rangeEnd = ((state.value[1] - min) * 100) / (max - min);

            return (
              <div
                {...props}
                className="range-track"
                style={{
                  background: `linear-gradient(to right, var(--white-10) ${rangeStart}%, var(--gradient-left) ${rangeStart}%, var(--gradient-right) ${rangeEnd}%, var(--white-10) ${rangeEnd}%, var(--white-10) 100%)`,
                }}
              />
            );
          }}
          renderThumb={(props, state) => (
            <div
              {...props}
              className={`range-thumb ${
                state.index === 0 ? "range-thumb-left" : "range-thumb-right"
              }`}
            />
          )}
          markClassName="range-marks"
          marks={true}
          renderMark={(props) => {
            const markValue = max - props.key * step;

            const newProps = {
              ...props,
              style: {
                ...props.style,
                left: Math.abs(props.style.left) + 6,
              },
            };
            return <span {...newProps} data-value={markValue} />;
          }}
          thumbActiveClassName="thumbActiveClassName"
        />

        <input type="hidden" name={props.minName || props.name} value={low} />
        <input type="hidden" name={props.maxName || props.name} value={high} />
      </div>
    );
  }
}

RangeInput.defaultProps = {
  step: 1,
};

RangeInput.contextType = RillContext;

export default RangeInput;
